import React from 'react'
import { ShowIf, dragSortTrailingDropZoneClassName, useDragSort } from '@ztechapps/webui.util'
import { ActualRow } from './ActualRow'
import styles from './RowSortable.module.scss'
import type { TableProps } from './index'

export const RowSortable = ({ onDragSort, dataArray, ...props }: TableProps) => {
  const { getItemProps, getHandleProps, getContainerProps, dragState } = useDragSort({
    items: dataArray ?? [],
    getItemKey: (row, i) => row?._id ?? String(i),
    onSort: (event) => onDragSort?.(event),
  })

  // While a drag handler is not supplied, render a plain tbody.
  if (!onDragSort) {
    return (
      <tbody>
        <ActualRow {...{ dataArray, ...props }} />
      </tbody>
    )
  }

  return (
    <tbody {...getContainerProps()}>
      <ActualRow
        {...{ dataArray, ...props }}
        getItemProps={getItemProps}
        getHandleProps={getHandleProps}
        dragRowClassName={styles.rowSortable}
      />
      {/* Trailing overshoot buffer below the last row, present only mid-drag. */}
      <ShowIf condition={dragState.isDragging}>
        <tr aria-hidden="true">
          <td colSpan={100} className={dragSortTrailingDropZoneClassName} />
        </tr>
      </ShowIf>
    </tbody>
  )
}
